import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  ReadOnlyToggle,
} from 'apps/builder/components/settings/fields/Base/standard'
import {
  BackgroundColor,
  Position,
  Dimensions,
} from 'apps/studio/components/settings/fields/Base/design'
import { lib } from '@gocanvas/client'
const { applyValidations } = lib

import { FieldsIcon } from '@gocanvas/gcds/icons'

// Using the same components from Builder so that we only need to maintain them in one place.
// Ideally when we get rid of Builder, we can move these components into this file.
export {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  ReadOnlyToggle,
}

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const DefaultValueInput = {
  label: 'Default',
  settingType: 'textInput',
  property: 'default',
  updateType: 'entry',
  validation: data => {
    return applyValidations(
      { ...data, value: data.default },
      { disableRequired: true }
    )
  },
  placeholder: ' ',
}

export const DefaultMultiLineValueInput = {
  label: 'Default',
  settingType: 'longTextInput',
  property: 'default',
  updateType: 'entry',
  validation: data => {
    return applyValidations(
      { ...data, value: data.default },
      { disableRequired: true }
    )
  },
  placeholder: ' ',
}

export const HideOnPdfToggle = {
  label: 'Hide On PDF',
  settingType: 'toggleInput',
  updateType: 'entry',
  property: 'pdf_visibility',
  tooltip: 'Enabling this setting will hide this field from your generated PDF report.',
  choices: [
    { value: 1, previousValue: 0 },
    { value: 0, previousValue: 1 },
  ],
}

export const HideOnFormToggle = {
  label: 'Hide On Form',
  settingType: 'toggleInput',
  updateType: 'entry',
  property: 'visible',
  tooltip: 'Enabling this setting will hide this field from the web form.',
  choices: [
    { value: false, previousValue: true },
    { value: true, previousValue: false },
  ],
}

export const BothHideToggles = [
  HideOnFormToggle,
  HideOnPdfToggle,
]

export const StandardDesignConfig = [
  SettingsLabel('Design'),
  Position,
  Dimensions,
  BackgroundColor,
]

export const StandardFieldConfig = [
  SettingsLabel('Config'),
  RequiredToggle,
  ReadOnlyToggle,
  ...BothHideToggles,
]

// basic field settings
export const Field = [
  SettingsLabel('Design'),
  LabelInput,
  EntryTypeSelect,
  ...StandardFieldConfig
]

export const FIELD_SETTINGS_PANEL = 'Field'

export const FieldSettingsPanel = (settings = []) => ({
  label: FIELD_SETTINGS_PANEL,
  icon: FieldsIcon,
  settings,
})
